import { Component } from '@angular/core';


@Component({
    selector: 'ui-block-loading',
    host: {
        'animate.enter': 'fade-enter',
        'style': '--fade-duration: 0.3s',
    },
    styles: [
        `
        :host {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            overflow: hidden;
        }

        .spinner-border {
            display: inline-block;
            width: 100px;
            height: 100px;
            vertical-align: text-bottom;
            border: 10px solid rgba(40, 43, 103, 0.15);
            border-top-color: rgb(40, 43, 103);
            border-radius: 50%;
            animation: spin 0.8s ease infinite, color 1.6s ease-in-out infinite;
        }

        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }

        @keyframes color {
            45% {
                border-color: rgba(76, 167, 71, 0.15);
                border-top-color: rgb(76, 167, 71);
            }
            95% {
                border-color: rgba(40, 43, 103, 0.15);
                border-top-color: rgb(40, 43, 103);
            }
        }
        `,
    ],
    template: `
        <div class="spinner-border"></div>
        <ng-content></ng-content>
    `,
})
export class BlockLoadingComponent {}
